<script setup lang="ts">
import { computed } from 'vue';
import {
  PortfolioAsset,
  PortfolioAssetType,
  getAddressFromAsset,
  getSymbolFromAsset,
} from '@sonarwatch/portfolio-core';
import BaseAmountToken from './BaseAmountToken.vue';
import type { TokenAmountFormatConfig } from '@/helpers/tokenAmountFormat';
import { useDataStore } from '@/store/data';
const store = useDataStore();

const props = defineProps<{
  asset: PortfolioAsset;
  hideLabel?: boolean;
}>();
const label = computed(() => {
  if (props.hideLabel) return undefined;
  const address = getAddressFromAsset(props.asset);
  const tokenInfo = store.getTokenInfo(address, props.asset.networkId);
  return getSymbolFromAsset(props.asset, tokenInfo);
});

const config = computed((): TokenAmountFormatConfig => {
  const isCollectible = props.asset.type === PortfolioAssetType.collectible;
  return {
    amount: props.asset.data.amount,
    hideLabel: props.hideLabel,
    isCollectible,
    label: label.value,
  };
});
</script>

<template>
  <BaseAmountToken :config="config" />
</template>
